// Archivo de vista para el detalle de un post
<template>
  <div class="post-detail-view">
    <template v-if="error">
      <div class="error-container">
        <h2>Error al cargar el post</h2>
        <p>{{ error }}</p>
      </div>
    </template>
    <template v-else-if="post">
      <AppPost :post="post" :allPosts="allPosts" />
    </template>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { postService } from '@/services/apiService';
import AppPost from './AppPost.vue';

export default {
  name: 'AppPostDetail',
  components: { AppPost },
  setup() {
    const route = useRoute();
    const post = ref(null);
    const allPosts = ref([]);
    const error = ref('');

    const loadPostAndContext = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) return;
      try {
        // Cargar todos los posts para contexto de padres/hijos
        allPosts.value = await postService.getAllPosts(token);
        post.value = allPosts.value.find(p => p.id == route.params.id);
      } catch (err) {
        console.error('Error loading post:', err);
        error.value = err.message || 'Imposible acceder al servidor';
      }
    };

    onMounted(loadPostAndContext);

    return { post, allPosts, error };
  }
};
</script>

<style scoped>
.post-detail-view {
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem 1rem;
}
</style>
